import { render, staticRenderFns } from "./estrategias.vue?vue&type=template&id=c72d0136&"
import script from "./estrategias.vue?vue&type=script&lang=ts&"
export * from "./estrategias.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports